import React from 'react';
import { Button } from './ui/button';

const ConceptSection = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="concept" className="py-32 md:py-40 bg-[#faf9f7]">
      <div className="container mx-auto px-6 md:px-12 lg:px-20">
        {/* Main Section */}
        <div className="max-w-5xl mx-auto">
          
          {/* Photo */}
          <div className="mb-16">
            <img
              src="https://customer-assets.emergentagent.com/job_divonne-dining/artifacts/2bv0iprw_ChatGPT%20Image%209%20mars%202026%2C%2023_35_57.png"
              alt="La Rotonde Restaurant"
              className="w-full h-auto object-contain"
            />
          </div>

          {/* Title */}
          <div className="text-center mb-12">
            <p 
              className="text-sm uppercase tracking-[0.3em] mb-6"
              style={{ 
                fontFamily: "var(--font-body)",
                color: "var(--color-gris-bleu)"
              }}
            >
              Le Restaurant
            </p>
            <h2 
              className="text-4xl md:text-5xl lg:text-6xl font-light mb-8 tracking-[0.08em] uppercase"
              style={{ 
                fontFamily: "var(--font-display)",
                color: "var(--color-bleu-nuit)"
              }}
            >
              Une nouvelle table
            </h2>
            <div className="w-16 h-px mx-auto" style={{ backgroundColor: "var(--color-gris-bleu)" }}></div>
          </div>

          {/* Description */}
          <div className="text-luxury-container text-center mb-20">
            <p 
              className="text-editorial"
              style={{ 
                fontFamily: "var(--font-body)",
                color: "var(--color-bleu-nuit-soft)",
                lineHeight: "1.9",
                letterSpacing: "0.01em",
                fontSize: "clamp(18px, 2vw, 20px)"
              }}
            >
              La Rotonde ouvre une nouvelle étape dans l'histoire d'un lieu emblématique.
              Anciennement connu sous le nom de Bon Accueil, le restaurant affirme aujourd'hui une
              identité renouvelée, fidèle à son héritage.
            </p>
          </div>

          {/* Second Section */}
          <div className="text-center mb-12">
            <h3 
              className="text-2xl md:text-3xl font-light mb-8 tracking-[0.06em] uppercase"
              style={{ 
                fontFamily: "var(--font-display)",
                color: "var(--color-bleu-nuit)"
              }}
            >
              Cuisine de saison & esprit de maison
            </h3>
            <div className="w-12 h-px mx-auto" style={{ backgroundColor: "var(--color-gris-bleu)" }}></div>
          </div>

          <div className="text-luxury-container text-center mb-16 space-y-8">
            <p 
              style={{ 
                fontFamily: "var(--font-body)",
                color: "var(--color-bleu-nuit-soft)",
                lineHeight: "1.9",
                letterSpacing: "0.01em",
                fontSize: "clamp(18px, 2vw, 20px)"
              }}
            >
              La cuisine du chef s'inspire de la tradition française et des produits de saison, avec
              une attention particulière portée à la précision des gestes et à la justesse des
              saveurs.
            </p>
            <p 
              style={{ 
                fontFamily: "var(--font-body)",
                color: "var(--color-bleu-nuit-soft)",
                lineHeight: "1.9",
                letterSpacing: "0.01em",
                fontSize: "clamp(18px, 2vw, 20px)"
              }}
            >
              La carte, volontairement courte et évolutive, privilégie la qualité des produits et le
              plaisir du partage.
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-5 justify-center">
            <Button
              onClick={() => scrollToSection('menu')}
              className="px-10 py-6 text-base tracking-wide transition-all duration-300 hover:-translate-y-1 shadow-lg"
              style={{ 
                fontFamily: "var(--font-body)",
                backgroundColor: "var(--color-bleu-nuit)",
                color: "white"
              }}
            >
              Voir la carte
            </Button>
            <Button
              onClick={() => scrollToSection('reservation')}
              variant="outline"
              className="px-10 py-6 text-base tracking-wide transition-all duration-300 hover:-translate-y-1"
              style={{ 
                fontFamily: "var(--font-body)",
                borderColor: "var(--color-bleu-nuit)",
                color: "var(--color-bleu-nuit)"
              }}
            >
              Réserver une table
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConceptSection;
